<atlas-modal
	open
	destroy-on-close="true"
	size="default"
	header="Compartilhe um link"
>
	<span class="description"
		>Seu cliente acessa a proposta completa, revisa as condições e responde
		com um aceite ou uma contraproposta. Tudo de forma rápida e
		segura.</span
	>

	<div class="links">
		@if (data.phone) {
			<div class="link-item">
				<div class="text-container">
					<span class="title">Enviar por WhatsApp</span>
					<span class="description"
						>Enviar um link de negociação para
						<span class="highlight">{{ data.phone }}</span></span
					>
				</div>
				<atlas-button
					(click)="openWhatsappLink()"
					description="Whatsapp"
					icon="whatsapp"
				/>
			</div>
		}
		@if (data.email) {
			@if (emailRequest$ | async; as emailRequest) {
				<div class="link-item">
					<div class="text-container">
						<span class="title">Enviar por E-mail</span>
						<span class="description"
							>Enviar um link de negociação para
							<span class="highlight">{{
								data.email
							}}</span></span
						>
					</div>
					<atlas-button
						[disabled]="emailRequest === 'LOADING'"
						[loading]="emailRequest === 'LOADING'"
						(click)="sendEmail()"
						description="E-mail"
						icon="envelope"
					/>
				</div>
			}
		}
		<div class="link-item">
			<div class="text-container">
				<span class="title">Link de compartilhamento</span>
				<span class="description"
					>Copie esse link para enviar para mais de uma pessoa</span
				>
			</div>
			<atlas-button
				type="ghost"
				description="Copiar link"
				icon="copy"
				[cdkCopyToClipboard]="data.paymentLink"
				(cdkCopyToClipboardCopied)="showAlertAfterLinkIsCopied()"
			/>
		</div>
	</div>
</atlas-modal>
